import {
  BooleanOptions,
  KitAlarms,
  KitStatuses,
  NvrDeviceTypes,
} from "@/components/constants.js"
import { CountryId, PowerType, CountryCode } from "@evercam/shared/types"
import { toTitleCase } from "@evercam/shared/utils"
import vendorModels from "@evercam/shared/constants/vendorModels"

export function getCountries() {
  return Object.keys(CountryId)
    .filter(isNaN)
    .map((key) => ({
      name: toTitleCase(key),
      value: CountryId[key],
      code: CountryCode[key],
    }))
    .sort((a, b) => a.name.localeCompare(b.name))
}

export default {
  name: {
    component: "TextFieldSearchFilter",
  },
  serial: {
    component: "TextFieldSearchFilter",
  },
  routerSerial: {
    component: "TextFieldSearchFilter",
  },
  sims: {
    component: "TextFieldSearchFilter",
  },
  nvrVersion: {
    component: "TextFieldSearchFilter",
  },
  nvrSerial: {
    component: "TextFieldSearchFilter",
  },
  nvrNerves: {
    component: "SelectSearchFilter",
    isGlobalFilter: true,
    width: 80,
    attributes: {
      items: [{ value: "", name: "All" }, ...BooleanOptions],
      label: "Nerves",
    },
  },
  ups: {
    component: "SelectSearchFilter",
    width: 80,
    isGlobalFilter: true,
    attributes: {
      items: [{ value: "", name: "All" }, ...BooleanOptions],
      label: "UPS",
    },
  },
  nvrModel: {
    component: "SelectSearchFilter",
    attributes: {
      items: [{ value: "", name: "All" }, ...vendorModels.NVRMODELS],
    },
  },
  nvrDeviceType: {
    component: "SelectSearchFilter",
    attributes: {
      items: [{ value: "", name: "All" }, ...NvrDeviceTypes],
    },
  },
  projectName: {
    component: "TextFieldSearchFilter",
  },
  status: {
    component: "SelectSearchFilter",
    attributes: {
      items: [{ value: "", name: "All" }, ...KitStatuses],
    },
  },
  alarms: {
    component: "SelectSearchFilter",
    attributes: {
      items: KitAlarms,
      multiple: true,
    },
  },
  countryId: {
    component: "SelectSearchFilter",
    attributes: {
      items: [{ value: "", name: "All" }, ...getCountries()],
      "menu-props": { offsetY: true },
      isAutocomplete: true,
    },
  },
  powerType: {
    component: "SelectSearchFilter",
    attributes: {
      items: Object.entries(PowerType)
        .filter(([_, value]) => value !== PowerType.Battery)
        .map(([name, value]) => ({
          name,
          value,
        })),
      multiple: true,
      "menu-props": { offsetY: true },
      isAutocomplete: true,
    },
  },
  tags: {
    component: "TagSearchFilter",
    attributes: {
      multiple: true,
    },
  },
  noTags: {
    component: "TagSearchFilter",
    attributes: {
      multiple: true,
    },
  },
}
